import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button, Card, CardBody } from "@odingard/design-system";
import { api } from "../../lib/api";

type State = "verifying" | "success" | "error";

export function Verify() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState<State>("verifying");
  const [message, setMessage] = useState("");

  useEffect(() => {
    let active = true;
    if (!token) {
      setState("error");
      setMessage("No verification token was provided.");
      return;
    }
    api
      .verifyEmail(token)
      .then((res) => {
        if (!active) return;
        setState("success");
        setMessage(res.email);
      })
      .catch((err: unknown) => {
        if (!active) return;
        setState("error");
        setMessage(err instanceof Error ? err.message : "This verification link is invalid or expired.");
      });
    return () => {
      active = false;
    };
  }, [token]);

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <Link to="/" className="brand" style={{ justifyContent: "center", marginBottom: "var(--ods-space-5)" }}>
          <span className="brand__mark">O</span> Odingard Studio
        </Link>
        <Card>
          <CardBody>
            <h1 style={{ fontSize: "var(--ods-text-xl)", marginTop: 0 }}>Email verification</h1>
            {state === "verifying" && <p>Verifying your email…</p>}
            {state === "success" && (
              <div className="banner banner--success" role="status">
                <strong>{message}</strong> is verified. Your account is fully secured.
              </div>
            )}
            {state === "error" && (
              <div className="banner banner--warning" role="alert">
                {message}
              </div>
            )}
            <Link to="/studio">
              <Button block style={{ marginTop: "var(--ods-space-4)" }}>
                Go to Studio
              </Button>
            </Link>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
